import { apartadosAjenos, comprometidosDe, getComprometidoPorEntregar, getProductosOPSinRemisionar, getStockProducto } from "../core/accounting.js";
import { C, DOC_INFO } from "../core/config.js";
import { state } from "../core/state.js";
import { escapeHTML, fmtCOP, formatMiles, inputStyle, normalize, parseNumber, searchBox } from "../core/utils.js";

export function renderInventario() {
  if (!state.invFiltros) state.invFiltros = { categoria:"", stockBajo:false };
  const filtros = state.invFiltros;
  const query = state.searches.inventario || "";

  const productos = state.data.productos || [];
  const categorias = [...new Set(productos.map(p => p.categoria).filter(Boolean))];

  // El inventario tiene dos cifras que no son la misma y confundirlas cuesta
  // caro: lo que hay FÍSICAMENTE en bodega (lo que vale, lo que el kardex mueve
  // con la remisión) y lo que se le puede PROMETER a un cliente nuevo, que es
  // menos cuando algo ya se facturó y está esperando su entrega.
  let filas = productos.map(p => {
    const stock = getStockProducto(p.nombre);
    const comprometido = getComprometidoPorEntregar(p.nombre, null);
    // Lo apartado en el flujo piloto para un pedido también tiene dueño.
    const apartados = apartadosAjenos(p.nombre, null);
    const apartado = apartados.reduce((s, a) => s + a.cantidad, 0);
    return {
      nombre: p.nombre,
      categoria: p.categoria || "—",
      costo: parseNumber(p.costo) || 0,
      stock, comprometido, apartado, apartados,
      disponible: stock - comprometido - apartado,
      duenos: comprometido > 0 ? comprometidosDe(p.nombre, null) : []
    };
  });

  if (query.trim()) {
    const q = normalize(query);
    filas = filas.filter(f => normalize(f.nombre).includes(q) || normalize(f.categoria).includes(q));
  }
  if (filtros.categoria) filas = filas.filter(f => f.categoria === filtros.categoria);
  if (filtros.stockBajo) filas = filas.filter(f => f.disponible <= 0);

  const valorTotalInventario = filas.reduce((s,f) => s + f.stock * f.costo, 0);
  const totalComprometido = filas.reduce((s,f) => s + f.comprometido, 0);
  const hayApartados = filas.some(f => f.apartado > 0);
  const sinRemisionar = getProductosOPSinRemisionar();

  const header = `
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:9px;padding-bottom:10px;border-bottom:3px solid ${C.gold};">
      <div style="display:flex;gap:10px;align-items:center;">
        <img src="${window.LOGO}" alt="Aura" style="height:42px;object-fit:contain;"/>
        <div>
          <h2 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">📦 Inventario</h2>
          <p style="margin:3px 0 0;color:${C.muted};font-size:11.5px;">Lo que hay en bodega y lo que se puede prometer${totalComprometido > 0 ? ` · ${formatMiles(totalComprometido)} und ya facturadas y pendientes de entregar` : ""}</p>
        </div>
      </div>
      <div style="text-align:right;">
        <div style="font-size:10.5px;color:${C.muted};font-weight:700;">VALOR TOTAL EN INVENTARIO (costo)</div>
        <div style="font-size:17px;font-weight:800;color:#f59e0b;">${fmtCOP(valorTotalInventario)}</div>
      </div>
    </div>
  `;

  const alertHTML = sinRemisionar.length === 0 ? "" : `
    <div style="background:#fffbeb;border:1px solid #fcd34d;border-radius:6px;padding:10px;margin-bottom:18px;">
      <div style="font-size:12px;font-weight:700;color:#92400e;margin-bottom:8px;">⚠️ Productos en OP pendientes por remisionar (${sinRemisionar.length})</div>
      <div style="overflow-x:auto;">
        <table style="width:100%;border-collapse:collapse;font-size:11.5px;">
          <thead><tr style="background:#fef3c7;">
            <th style="padding:6px 8px;text-align:left;font-size:10px;color:#92400e;">OP</th>
            <th style="padding:6px 8px;text-align:left;font-size:10px;color:#92400e;">Artículo</th>
            <th style="padding:6px 8px;text-align:right;font-size:10px;color:#92400e;">Pendiente</th>
            <th style="padding:6px 8px;text-align:right;font-size:10px;color:#92400e;">Stock disponible</th>
            <th style="padding:6px 8px;text-align:center;font-size:10px;color:#92400e;">¿Alcanza?</th>
          </tr></thead>
          <tbody>
            ${sinRemisionar.map(r => `
              <tr style="border-top:1px solid #fde68a;">
                <td style="padding:6px 8px;"><span data-action="ir-a-documento" data-tipo="OP" data-id="${r.opId}" style="color:${DOC_INFO.OP.color};font-weight:700;cursor:pointer;text-decoration:underline;">${escapeHTML(r.opNumero)}</span></td>
                <td style="padding:6px 8px;">${escapeHTML(r.articulo)}</td>
                <td style="padding:6px 8px;text-align:right;font-weight:700;">${r.pendiente}</td>
                <td style="padding:6px 8px;text-align:right;">${r.stock}</td>
                <td style="padding:6px 8px;text-align:center;">${r.stock >= r.pendiente ? "✅" : "⚠️ Falta " + (r.pendiente - r.stock)}</td>
              </tr>
            `).join("")}
          </tbody>
        </table>
      </div>
    </div>
  `;

  const filtersHTML = `
    <div style="display:flex;gap:10px;align-items:flex-end;margin-bottom:9px;flex-wrap:wrap;">
      <div style="flex:1;min-width:220px;">${searchBox("search-inventario", query, "Buscar producto por nombre o categoría...", "#f59e0b")}</div>
      <div>
        <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">Categoría</label>
        <select style="${inputStyle}width:160px;cursor:pointer;" onchange="state.invFiltros.categoria=this.value;render();">
          <option value="">Todas</option>
          ${categorias.map(c => `<option value="${escapeHTML(c)}" ${filtros.categoria===c?"selected":""}>${escapeHTML(c)}</option>`).join("")}
        </select>
      </div>
      <div>
        <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">&nbsp;</label>
        <label style="display:flex;align-items:center;gap:6px;font-size:11.5px;color:${C.text};cursor:pointer;padding:8px 11px;border:1px solid ${C.border};border-radius:7px;background:white;">
          <input type="checkbox" ${filtros.stockBajo?"checked":""} onchange="state.invFiltros.stockBajo=this.checked;render();"/> Solo sin disponible (≤0)
        </label>
      </div>
    </div>
  `;

  const tabla = filas.length === 0 ? `
    <div style="padding:22px;text-align:center;background:white;border:2px dashed ${C.border};border-radius:6px;color:${C.muted};">
      <div style="font-size:30px;margin-bottom:8px;">📦</div>
      Sin productos para mostrar
    </div>
  ` : `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;overflow:auto;">
      <table style="width:100%;border-collapse:collapse;font-size:12px;">
        <thead><tr style="background:#f1f5f9;">
          <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Producto</th>
          <th style="padding:6px 10px;text-align:left;font-size:10.5px;font-weight:700;color:${C.text};">Categoría</th>
          <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};" title="Unidades físicas en bodega">En bodega</th>
          <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};" title="Ya facturadas a un cliente y esperando su entrega: están en bodega pero tienen dueño">Vendido sin entregar</th>
          ${hayApartados ? `<th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};" title="Reservado en el flujo piloto para un pedido: está en bodega pero tiene dueño">Apartado</th>` : ""}
          <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};" title="Lo que se le puede prometer a un cliente nuevo">Disponible</th>
          <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">Costo unit.</th>
          <th style="padding:6px 10px;text-align:right;font-size:10.5px;font-weight:700;color:${C.text};">Valor en inventario</th>
        </tr></thead>
        <tbody>
          ${filas.map(f => `
            <tr style="border-top:1px solid ${C.border};">
              <td style="padding:6px 10px;font-weight:600;">${escapeHTML(f.nombre)}</td>
              <td style="padding:6px 10px;color:${C.muted};">${escapeHTML(f.categoria)}</td>
              <td style="padding:6px 10px;text-align:right;color:${C.muted};">${formatMiles(f.stock)}</td>
              <td style="padding:6px 10px;text-align:right;font-weight:${f.comprometido>0?700:400};color:${f.comprometido>0?'#b45309':C.muted};"
                  title="${f.comprometido>0?escapeHTML(f.duenos.map(d=>`${d.cantidad} · ${d.cliente||"cliente"} (factura ${d.factura})`).join(" | ")):""}">${f.comprometido>0?formatMiles(f.comprometido):"—"}</td>
              ${hayApartados ? `<td data-inv-apartado="${escapeHTML(f.nombre)}" style="padding:6px 10px;text-align:right;font-weight:${f.apartado>0?700:400};color:${f.apartado>0?'#0f766e':C.muted};"
                  title="${f.apartado>0?escapeHTML(f.apartados.map(a=>`${a.cantidad} · ${a.pedido_numero}`).join(" | ")):""}">${f.apartado>0?formatMiles(f.apartado):"—"}</td>` : ""}
              <td style="padding:6px 10px;text-align:right;font-weight:700;color:${f.disponible<=0?'#ef4444':C.text};">${formatMiles(f.disponible)}</td>
              <td style="padding:6px 10px;text-align:right;">${fmtCOP(f.costo)}</td>
              <td style="padding:6px 10px;text-align:right;font-weight:700;">${fmtCOP(f.stock*f.costo)}</td>
            </tr>
          `).join("")}
        </tbody>
      </table>
    </div>
  `;

  return `
    ${header}
    ${alertHTML}
    ${filtersHTML}
    ${tabla}
  `;
}
